<template>
  <div
    v-if="['sent', 'open'].includes(paymentLinkStatus) > -1 && payment === null"
  >
    <el-tooltip content="Copy Payment Link" placement="bottom">
      <div :class="classes">
        <span :class="getClassByStatusPayment(payment, paymentLinkStatus)">
          {{
            getStatusPayment(payment, paymentType, paymentLinkStatus, status)
          }}
        </span>
        <span
          class="d-block f-10"
          v-clipboard:copy="paymentLink"
          v-clipboard:success="copyPaymentLink"
          v-clipboard:error="onErrorCopyPaymentLink"
        >
          {{ getContentByStatusPayment(payment, paymentLinkStatus) }}
          <i class="flaticon-copy"></i>
        </span>
      </div>
    </el-tooltip>
  </div>

  <div v-else :class="classes">
    <span :class="getClassByStatusPayment(payment, paymentLinkStatus)">
      {{ getStatusPayment(payment, paymentType, paymentLinkStatus, status) }}
    </span>
    <span class="d-block f-10">
      {{ getContentByStatusPayment(payment, paymentLinkStatus) }}
    </span>
  </div>
</template>

<script>
export default {
  name: "PaymentStatus",
  props: {
    payment: {
      type: [Object, String],
      default: null,
      description: ""
    },
    paymentLink: {
      type: String,
      default: "pending",
      description: ""
    },
    paymentLinkStatus: {
      type: String,
      default: "pending",
      description: ""
    },
    paymentType: {
      type: String,
      default: "credit"
    },
    status: {
      type: String,
      default: "credit"
    },
    classes: {
      type: String,
      default: "",
      description: "class of the text"
    }
  },
  components: {},
  data() {
    return {
      paid_list: ["open", "sent", "pending", "expired"]
    };
  },
  async created() {},
  methods: {
    getStatusPayment(
      payment,
      paymentType,
      paymentLinkStatus,
      reservationStatus
    ) {
      if (payment) {
        if (paymentLinkStatus === "refund") {
          return "Paid";
        } else {
          return "Paid";
        }
      } else {
        if (paymentType == "credit") {
          if (reservationStatus !== "PNDG") {
            return "On credit";
          } else {
            return "Unpaid";
          }
        } else {
          return "Unpaid";
        }
      }
    },
    getIconByStatusPayment(payment, paymentLinkStatus) {
      if (payment) {
        if (paymentLinkStatus === "refund") {
          return "flaticon-money-back-guarantee danger";
        } else {
          return "";
        }
      } else {
        if (paymentLinkStatus === "sent") {
          return "flaticon-email";
        } else if (paymentLinkStatus === "open") {
          return "flaticon-visualization";
        } else if (paymentLinkStatus === "expired") {
          return "flaticon-clock";
        } else {
          return "";
        }
      }
    },
    getContentByStatusPayment(payment, paymentLinkStatus) {
      if (payment) {
        if (paymentLinkStatus === "refund") {
          return "Refund";
        } else {
          return "Paid";
        }
      } else {
        if (paymentLinkStatus === "sent") {
          return "Link Sent";
        } else if (paymentLinkStatus === "open") {
          return "Link Viewed";
        } else if (paymentLinkStatus === "expired") {
          return "Link Expired";
        } else if (paymentLinkStatus === "refund") {
          return "Refund";
        } else {
          return "Pending";
        }
      }
    },
    getClassByStatusPayment(payment, paymentLinkStatus) {
      if (payment) {
        if (paymentLinkStatus === "refund") {
          return "text-success status-paid";
        } else {
          return "text-success";
        }
      } else {
        if (paymentLinkStatus === "pending") {
          return "text-danger";
        } else if (paymentLinkStatus === "refund") {
          return "text-danger";
        } else {
          return "text-warning status-paid";
        }
      }
    },
    getIconByStatusPayment(payment, paymentLink) {
      if (payment) {
        if (paymentLink === "refund") {
          return "flaticon-money-back-guarantee text-danger";
        } else {
          return "";
        }
      } else {
        if (paymentLink === "sent") {
          return "flaticon-mail";
        } else if (paymentLink === "open") {
          return "flaticon-view-1";
        } else if (paymentLink === "expired") {
          return "flaticon-wall-clock-1";
        } else if (paymentLink === "refund") {
          return "flaticon-money-back-guarantee";
        } else {
          return "";
        }
      }
    },
    getPaymentLinkStatus(payment, paymentLink) {
      if (payment) {
        if (paymentLink === "refund") {
          return "Refund";
        } else {
          return "Paid";
        }
      } else {
        if (paymentLink === "sent") {
          return "Link Sent";
        } else if (paymentLink === "open") {
          return "Link Viewed";
        } else if (paymentLink === "expired") {
          return "Link Expired";
        } else if (paymentLink === "refund") {
          return "Refund";
        } else {
          return "Unpaid";
        }
      }
    },
    copyPaymentLink() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The payment link has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopyPaymentLink() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The payment link could not be copied",
        icon: "flaticon-remove"
      });
    }
  },
  computed: {},
  filters: {}
};
</script>
